// US 502158: retains MpciTable filter/sort/pagination state across navigation within the
// same MPCI sub-module (e.g. House Bill list -> edit -> back to list), and clears it when the
// user leaves to a different sub-module or ends the session (sessionStorage, per-user stamped).

const RETAINED_PREFIX = 'mpci_retained_'

function getSubModuleSlug(pathname) {
  const match = /^\/uae-mpci\/([^/]+)/.exec(pathname ?? '')
  return match ? match[1] : null
}

function saveRetainedState(key, state, userId) {
  try {
    sessionStorage.setItem(RETAINED_PREFIX + key, JSON.stringify({ userId: userId ?? null, state }))
  } catch (e) {
    // sessionStorage unavailable (private mode / quota) - retention silently no-ops
  }
}

function loadRetainedState(key, userId) {
  try {
    const raw = sessionStorage.getItem(RETAINED_PREFIX + key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed.userId !== (userId ?? null)) {
      // different user in this tab (e.g. logout + relogin) - stale, discard
      sessionStorage.removeItem(RETAINED_PREFIX + key)
      return null
    }
    return parsed.state ?? null
  } catch (e) {
    return null
  }
}

function clearAllRetainedStates() {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(RETAINED_PREFIX))
      .forEach((k) => sessionStorage.removeItem(k))
  } catch (e) {
    // ignore
  }
}

// Module-singleton: attached once (from whichever retaining MpciTable mounts first) and lives
// for the app session, so it keeps tracking sub-module changes even while that table is unmounted
// (e.g. while the user is on an Add/Edit/View page).
let watcherAttached = false
let lastSlug

function watchSubModuleChanges(history) {
  if (watcherAttached || !history) return
  watcherAttached = true
  lastSlug = getSubModuleSlug(history.location?.pathname)
  history.listen((location) => {
    const slug = getSubModuleSlug(location.pathname)
    if (slug !== lastSlug) {
      clearAllRetainedStates()
    }
    lastSlug = slug
  })
}

export {
  getSubModuleSlug,
  saveRetainedState,
  loadRetainedState,
  clearAllRetainedStates,
  watchSubModuleChanges
}
